import type { ServerFormError } from 'src/utils/serverFormErrors';

/**
 * Flatten react-hook-form FieldErrors into ServerFormError[] for FormErrorsDrawer.
 */
export function flattenFieldErrors(errors: Record<string, any>, prefix = ''): ServerFormError[] {
  const result: ServerFormError[] = [];
  for (const key of Object.keys(errors)) {
    const value = errors[key];
    const path = prefix ? `${prefix}.${key}` : key;
    if (value?.message && typeof value.message === 'string') {
      result.push({ path, message: value.message });
    } else if (Array.isArray(value)) {
      value.forEach((item, index) => {
        if (item && typeof item === 'object') {
          result.push(...flattenFieldErrors(item, `${path}.${index}`));
        }
      });
    } else if (value && typeof value === 'object') {
      result.push(...flattenFieldErrors(value, path));
    }
  }
  return result;
}

/** Пути ошибок, которые в форме зарегистрированы под другим именем (RHF name). */
export function resolveFocusFieldPath(path: string): string {
  if (path === 'contract_id' || path.startsWith('contract_id.')) {
    return path.replace(/^contract_id/, 'contract');
  }
  return path;
}
